export function filterMenuDetailBySelected(menuDetailData) {
  if (!Array.isArray(menuDetailData)) return [];

  return menuDetailData
    .filter((item) => item.isSelected === true)
    .map((item) => ({
      ...item,
      children: filterMenuDetailBySelected(item.children || []),
    }));
}

export function transformMenuDetailToTabsConfig(menuDetailData) {
  if (!Array.isArray(menuDetailData)) return [];

  return menuDetailData.map((menu) => {
    const children = menu.children || [];
    const subMenuItems = children.filter((c) => c.menuType === 'SUB_MENU');
    const permissionOnly = children.filter((c) => c.menuType === 'PERMISSION');

    const subMenus =
      subMenuItems.length > 0
        ? subMenuItems.map((sub) => ({
            id: sub.id,
            label: sub.displayName ?? sub.name,
            isSelected: sub.isSelected,
            permissions: (sub.children || []).map((p) => ({
              id: p.id,
              displayName: p.displayName ?? p.name,
              permissionId: p.id,
              name: p.name,
              isSelected: p.isSelected === true,
            })),
          }))
        : permissionOnly.length > 0
        ? [
            {
              id: menu.id,
              label: menu.displayName ?? menu.name,
              isSelected: menu.isSelected,
              permissions: permissionOnly.map((p) => ({
                id: p.id,
                displayName: p.displayName ?? p.name,
                permissionId: p.id,
                name: p.name,
                isSelected: p.isSelected === true,
              })),
            },
          ]
        : [];

    return {
      id: menu.id,
      label: menu.displayName ?? menu.name,
      displayName: menu.displayName ?? menu.name,
      name: menu.name,
      isSelected: menu.isSelected,
      subMenus,
    };
  });
}
